import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="14"
      height="4"
      viewBox="0 0 14 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.09382 0.90625H0.766472C0.344195 0.90625 0 1.24772 0 1.67011V2.33164C0 2.75358 0.344195 3.09368 0.766472 3.09368H8.09371H13.2343C13.6565 3.09368 14 2.7537 14 2.33164V1.67011C14 1.24772 13.6564 0.90625 13.2343 0.90625H8.09382Z"
        fill="#C4C4C4"
      />
    </Svg>
  );
};

export default Icon;
